// Proprietà e costanti di configurazione per la tabella calibrazioni

export const tableColumns = [
  { name: 'row_num', title: '#', getCellValue: row => row.row_num, isNumber: true },
  // { name: 'id', title: 'ID', getCellValue: row => row.id, isNumber: true },
  { name: 'actions', title: 'Actions', getCellValue: row => row },
  { name: 'created_at', title: 'Created At', getCellValue: row => row.created_at },
  { name: 'updated_at', title: 'Updated At', getCellValue: row => row.updated_at },
  { name: 'name', title: 'Name', getCellValue: row => row.name },
  // { name: 'original_filename', title: 'File Name', getCellValue: row => row.original_filename },
  { name: 'file_size', title: 'File Size', getCellValue: row => row.file_size, isNumber: true },
  { name: 'com_brand', title: 'Com Brand', getCellValue: row => row.com_brand },
  { name: 'ecu_type', title: 'ECU Type', getCellValue: row => row.ecu_type },
  { name: 'injector', title: 'Injector', getCellValue: row => row.injector },
  { name: 'fw_version', title: 'FW', getCellValue: row => row.fw_version },
  { name: 'sw_version', title: 'SW', getCellValue: row => row.sw_version },
  { name: 'usage_info', title: 'Usage Info', getCellValue: row => row.usage_info },
  { name: 'status', title: 'Status', getCellValue: row => row.status },
];

export const tableColumnWidths = [
  { columnName: 'row_num', width: 60 },
  { columnName: 'id', width: 80 },
  { columnName: 'actions', width: 140 },
  { columnName: 'created_at', width: 120 },
  { columnName: 'updated_at', width: 120 },
  { columnName: 'name', width: 500 },
  { columnName: 'file_size', width: 100 },
  { columnName: 'com_brand', width: 80 },
  { columnName: 'ecu_type', width: 120 },
  { columnName: 'injector', width: 110 },
  { columnName: 'fw_version', width: 110 },
  { columnName: 'sw_version', width: 110 },
  { columnName: 'usage_info', width: 280 },
  { columnName: 'status', width: 120 },
];

/**
 * @type {import('@devexpress/dx-react-grid-material-ui').ColumnExtension[]}
 */
export const tableColumnExtensions = [
  { columnName: 'row_num', align: 'right' },
  { columnName: 'id', align: 'right' },
  { columnName: 'file_size', align: 'right' },
  { columnName: 'created_at', align: 'right' },
  { columnName: 'updated_at', align: 'right' },  
];

export const tableFilteringStateColumnExtensions = [
  { columnName: 'row_num', filteringEnabled: false },
  { columnName: 'actions', filteringEnabled: false },
  { columnName: 'created_at', filteringEnabled: false },
  { columnName: 'updated_at', filteringEnabled: false },
];

export const tableSortingStateColumnExtensions = [
  { columnName: 'row_num', sortingEnabled: false },
  { columnName: 'id', sortingEnabled: false },
  { columnName: 'actions', sortingEnabled: false },
  { columnName: 'created_at', sortingEnabled: true }, // !!!
  { columnName: 'updated_at', sortingEnabled: true }, // !!!
  { columnName: 'name', sortingEnabled: true }, // !!!
  { columnName: 'file_size', sortingEnabled: true }, // !!!
  { columnName: 'com_brand', sortingEnabled: false },
  { columnName: 'ecu_type', sortingEnabled: false },
  { columnName: 'injector', sortingEnabled: false },
  { columnName: 'fw_version', sortingEnabled: false },
  { columnName: 'sw_version', sortingEnabled: false },
  { columnName: 'usage_info', sortingEnabled: false },
  { columnName: 'status', sortingEnabled: false },
];
